/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import * as React from 'react';
import { Router, Route } from 'react-router-dom';
import type { History } from 'history';

import {
  EntiteZustandProvider,
  ProduitDomaineZustandProvider,
  UtilisateurZustandProvider,
} from '../Zustand';

import type { UtilisateurType } from '@/zustand/useUtilisateurStore';

interface ContextProps {
  children: React.ElementType;
  path: string;
  history: History;
  scope: string;
  user: UtilisateurType;
}

const Context = (p: ContextProps) => {
  const { children, path, history, scope, user } = p;

  return (
    <Router history={history}>
      <Route path={path}>
        {scope === 'content' ? (
          <ProduitDomaineZustandProvider>
            <EntiteZustandProvider>
              <UtilisateurZustandProvider user={user}>
                {React.isValidElement(children)
                  ? children
                  : React.createElement(children)}
              </UtilisateurZustandProvider>
            </EntiteZustandProvider>
          </ProduitDomaineZustandProvider>
        ) : React.isValidElement(children) ? (
          children
        ) : (
          React.createElement(children)
        )}
      </Route>
    </Router>
  );
};

export default Context;
